import { SupabaseGroupedMomentAnalyticsDataService } from "../../../../modules/stats/server/analytics-service";
import { useSupabaseLoader } from "../../../../server/supabase/hooks";

import type { GroupedMomentAnalyticsData } from "../../../../modules/stats/server/analytics-service";
import type { UseSupabaseLoaderState } from "../../../../server/supabase/hooks/types";
import type { UUID } from "../../../../utils/uuid";

export const useGroupedMomentStats = ({
  moment_id,
  moment_grouping_id,
}: {
  moment_id: UUID;
  moment_grouping_id: UUID | null;
}): UseSupabaseLoaderState<GroupedMomentAnalyticsData["stats"]> =>
  useSupabaseLoader(
    async ({ supabase, account_id }) => {
      // A grouping is identified by moment_grouping_id; without one there is no single row to read.
      if (!moment_grouping_id) return [];

      const service = new SupabaseGroupedMomentAnalyticsDataService(supabase);
      const resp = await service.client
        .from(service.table)
        .select("stats")
        .eq("account_id", account_id)
        .eq("moment_id", moment_id)
        .eq("moment_grouping_id", moment_grouping_id)
        .maybeSingle();

      if (resp.error) throw resp.error;

      return resp.data?.stats ?? [];
    },
    [moment_id, moment_grouping_id],
  );
